import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import getLanguageFromBrowser from 'frontend-utils/utils/browser-language';

export default class ApplicationRoute extends Route {
  @service declare intl: Services['intl'];
  @service declare router: Services['router'];

  beforeModel(): void {
    const language = getLanguageFromBrowser();
    this.intl.setLocale([language]);
  }

  redirect(model: void, transition: Transition): void {
    if (transition.targetName === 'index') {
      this.router.transitionTo('login');
    }
  }
}
